<template>
  <div class="page">
    <div v-if="upIdcard==1" class="m-nav">
      <div class="m-title">
        <span class="m-des">身份证照片</span>
      </div>
      <p class="m-p">上传与注册信息一致的身份证照片</p>
      <div class="m-up-box">
        <div class="m-file-box">
          <van-uploader class="m-top-margin" :multiple="true" :max-count="1" :before-read="beforeRead"
                        :after-read="(e)=> afterRead(e,1)" accept="image/*">
            <img :src="fileHome ? fileHome : require('@/assets/img/home/Groups788.png')" alt="">
          </van-uploader>
        </div>
        <div class="m-file-box">
          <van-uploader class="m-top-margin" :multiple="true" :max-count="1" :before-read="beforeRead"
                        :after-read="(e)=> afterRead(e,2)" accept="image/*">
            <img :src="fileBack ? fileBack : require('@/assets/img/home/Groups978.png')" alt="">
          </van-uploader>
        </div>
      </div>
      <!--示例-->
      <div class="m-prompt">
        <p>上传示例</p>
        <div class="m-prompt-box">
          <div class="m-nav-prompt">
            <img src="@/assets/img/home/sda.png" alt="">
            <van-icon class="m-icon" name="checked" />
            <span>标准</span>
          </div>
          <div class="m-nav-prompt">
            <img src="@/assets/img/home/xczx.png" alt="">
            <van-icon class="m-icon-w" name="warning" />
            <span>边框缺失</span>
          </div>
          <div class="m-nav-prompt">
            <img src="@/assets/img/home/sdaszx.png" alt="">
            <van-icon class="m-icon-w" name="warning" />
            <span>对焦模糊</span>
          </div>
          <div class="m-nav-prompt">
            <img src="@/assets/img/home/zsd.png" alt="">
            <van-icon class="m-icon-w" name="warning" />
            <span>反光强烈</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="upImage==1" class="m-nav">
      <div class="m-title">
        <span class="m-des">证件照片</span>
      </div>
      <div class="m-card-box">
        <div class="m-card-item">
          <!--开启ai制图-->
          <img v-if="aiOnOff!=1" src="@/assets/img/home/wxtu_20240103161550_43.png" alt="">
          <p v-if="aiOnOff!=1" class="m-left-p">证件照示例</p>
          <p v-if="aiOnOff!=1">大小4M以下</p>
          <div class="m-ai-box" v-if="aiOnOff==1">
            <span v-if="!aiCard">请先在右侧上传证件照片</span>
            <img v-else="" :src="aiCard" alt="">
          </div>
          <p class="m-ai" v-if="aiOnOff==1">AI处理后照片</p>
        </div>
        <div class="m-card-item">
          <van-uploader class="m-top-margin" :multiple="true" :max-count="1" :before-read="beforeRead"
                        :after-read="(e)=> afterRead(e,3)" accept="image/*">
            <img class="m-up-card" :src="fileCard ? fileCard : require('@/assets/img/home/Group21056.png')" alt="">
          </van-uploader>
          <p class="m-right-p">点击上传证件照片</p>
        </div>
      </div>
    </div>
    <div class="des-bg">
      <div class="m-html ql-editor" v-html="aiText"></div>
      <!--<p>温馨提示: </p>-->
      <!--<p>1、身份证信息必须与注册信息一致，如不一致请在个人信息中修改姓名或身份证号</p>-->
      <!--<p v-if="upImage==1">2、上传考生本人清晰近期正面免冠彩色证件照。成像区上下要求头上部空1/10，头部占7/10，肩部占1/5，左右各空1/10。采集的图象大小最小为192×144（高×宽），成像区大小为48mm×33mm（高×宽）</p>-->
    </div>
    <van-button v-if="faceType==0||faceType==null||faceType==undefined" block class="x-btn-log m-btn" @click="submit()">提交</van-button>
    <van-button block class="x-btn-log m-btn" @click="submit()" v-else="" >下一步</van-button>
  </div>
</template>

<script>
  import { Dialog } from 'vant';
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import { JudgeCompress } from '@/assets/js/compress/handleImage'
  export default {
    components: {
      [Dialog.Component.name]: Dialog.Component,
    },
    data () {
      return {
        fileHome: '',
        fileBack: '',
        fileCard: '',
        upIdcard:'',
        upImage:'',
        faceType:1,
        aiOnOff: 0,
        aiText: '',
        aiCard:'',
      }
    },
    created () {
      this.getTenant()
    },
    methods: {
      beforeRead(e){
        if (e.type !== 'image/jpeg'&&e.type !== 'image/jpg'&&e.type !== 'image/png') {
          this.utils.toastError('请上传 jpg, jpeg, png 格式图片');
          return false;
        }
        if(e.length>1){
          this.utils.toastError('只能选择一张图片上传！')
          return false
        }
        if(e.size>4194304){
          this.utils.toastError('文件大小不能超过4MB！')
          return false
        }
        return true
      },
      afterRead (e,keys) {
        if(keys==1){
          this.postHomeFile(e.content)
        } else if(keys==2) {
          this.postBackFile(e.content)
        } else {
          JudgeCompress(e.file,200).then((e)=>{
            this.postCardFile(e)
          })
        }
      },
      submit(){
        if(this.upIdcard==1&&!this.fileHome){
          this.utils.toastNone('请上传身份证正面照！')
          return
        }
        if(this.upIdcard==1&&!this.fileBack){
          this.utils.toastNone('请上传身份证反面照!')
          return
        }
        if(this.upImage==1&&!this.fileCard){
          this.utils.toastNone('请上传证件照!')
          return
        }
        this.http.postRequest({
          url:'app/userInfo/applyCheckInsertThree',
          msg:{idCardNum:this.$route.query.idCardNum},
          success:(res)=>{
            if(res.code==200){
              this.goSubmit()
            }
          }
        },true)
      },
      //上传正面照
      postHomeFile(e){
        if(!this.$route.query.idCardNum){
          this.utils.toastNone('缺少必要参数！')
          return
        }
        this.http.postRequest({
          url: 'app/userInfo/readIdcardFront',
          msg: {
            imgBase64:e,
            idCardNum:this.$route.query.idCardNum
          },
          special:true,
        },true).then((res)=>{
          if(res.code==500){
            Dialog.alert({
              title: '身份证正面照认证失败',
              message: res.msg||res.code,
              confirmButtonColor: '#2B6CF9',
            }).then(() => {})
          }
          if(res.code==200){
            this.fileHome = e
          }
        },true)
      },
      //上传反面照
      postBackFile(e){
        if(!this.$route.query.idCardNum){
          this.utils.toastNone('缺少必要参数！')
          return
        }
        this.http.postRequest({
          url: 'app/userInfo/readIdcardBack',
          msg: {
            imgBase64:e,
            idCardNum:this.$route.query.idCardNum
          },
          special:true,
        },true).then((res)=>{
          if(res.code==500){
            Dialog.alert({
              title:'身份证反面照认证失败',
              message: res.msg||res.code,
              confirmButtonColor: '#2B6CF9',
            }).then(() => {})
          }
          if(res.code==200){
            this.fileBack = e
          }
        },true)
      },
      //上传证件照
      postCardFile(e){
        if(!this.$route.query.idCardNum){
          this.utils.toastNone('缺少必要参数！')
          return
        }
        //开启ai制图
        if(this.aiOnOff==1){
//          console.log(e)
          let arr = e.split('base64,')
          let oneTitle = arr[0]+'base64,'
          let towTitle = arr[1]
          this.http.postRequest({
            url: 'visitor/remote/res/idPhotoMaker',
            msg:{base64:towTitle},
            special:true,
          },true).then((res)=>{
            if(res.code!=200){
              Dialog.alert({
                title:'证件照上传失败',
                message: res.msg||res.code,
                confirmButtonColor: '#2B6CF9',
              }).then(() => {})
            }
            if(res.code==200){
               let aiUrl = JSON.parse(res.data).image
//              console.log('ai',JSON.parse(res.data))
//              return
              this.upFiles(aiUrl,oneTitle,e)
            }
          })
        } else {
          this.upFiles(e)
        }
      },
      upFiles(e,oneTitle,oldCard){
        let fils = ''
        if(oneTitle){
          fils = oneTitle + e
        }else {
          fils = e
        }
        this.http.postRequest({
          url: 'app/userInfo/uploadCardPhoto',
          msg: {
            imgBase64:fils,
            idCardNum:this.$route.query.idCardNum
          },
          special:true,
        },true).then((res)=>{
          if(res.code==500){
            Dialog.alert({
              title:'证件照上传失败',
              message: res.msg||res.code,
              confirmButtonColor: '#2B6CF9',
            }).then(() => {})
          }
          if(res.code==200){

            if(this.aiOnOff==1){
              this.aiCard = fils
              this.fileCard = oldCard
            } else {
              this.fileCard = fils
            }
          }
        },true)
      },
      //获取设置
      getTenant(){
        this.http.getRequest({
          url:'app/userInfo/tenantNoLogin',
          msg:{},
          success:(res)=>{
            this.upIdcard = res.data.upIdcard
            this.upImage = res.data.upImage
            this.faceType = res.data.faceType
            this.aiOnOff = res.data.aiOnOff
            this.aiText = res.data.aiText
          }
        })
      },
      //提交或者跳转
      goSubmit(){
        if(this.faceType!=1&&this.faceType!=2){
          this.http.postRequest({
            url:'app/userInfo/applyInsert',
            msg:{idCardNum:this.$route.query.idCardNum},
            success:(res)=>{
              this.utils.toastSuccess('申请成功!')
              this.$router.replace({
                path:'/applySuccess'
              })
            }
          },true)
        } else {
          this.$router.push({
            path:this.faceType==1 ? '/appFace' : '/appLiveFace',
            query:{
              idCardNum:this.$route.query.idCardNum
            }
          })
        }
      },
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .page {
    background: #F4F6F9;
    padding: 0 12px 50px 12px;
    .m-nav {
      margin-top: 15px;
      background: #ffffff;
      border-radius: 4px;
      padding: 15px;
      .m-title:before{
        display: inline-block;
        content: '';
        width: 4px;
        height: 18px;
        background: #457DF9;
        border-radius: 2px;
        margin-right: 4px;
      }
      .m-title {
        display: flex;
        align-items: center;
        margin-bottom: 9px;
        .m-des{
          font-size: 15px;
          color: #457DF9;
          font-weight: bold;
        }
      }
      .m-p{
        font-size: 14px;
        color: #FB2927;
      }
      .m-up-box{
        margin: 20px 10px 30px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap:30px;
        .m-file-box{
          width: 130px;
          img{
            width: 130px;
            height: 82px;
          }
        }
      }
      .m-prompt{
        width: 100%;
        padding: 10px 15px 12px 15px;
        background: #F9F9F9;
        border-radius: 4px;
        >p{
          text-align: center;
          color: #333333;
          font-size: 13px;
          margin-bottom: 11px;
        }
        .m-prompt-box{
          display: flex;
          align-items: center;
          justify-content: space-between;
          .m-nav-prompt{
            display: flex;
            flex-direction: column;
            align-items: center;
            >img{
              width: 56px;
              height: 36px;
            }
            .m-icon{
              color: #4ADC47;
              font-size: 13px;
              margin-top: 6px;
              margin-bottom: 8px;
            }
            .m-icon-w{
              color: #F44442;
              font-size: 13px;
              margin-top: 6px;
              margin-bottom: 8px;
            }
            >span{
              font-size: 12px;
              color: #666666;
            }
          }
        }
      }
      .m-card-box{
        display: flex;
        padding: 0 34px;
        justify-content: space-between;
        .m-card-item{
          >img{
            width: 100px;
            height: 130px;
            margin-top: 3px;
          }
          .m-up-card{
            width: 109px;
            height: 137px;
          }
          >p{
            text-align: center;
            color: #666666;
            line-height: 18px;
          }
          .m-left-p{
            margin-top: 15px;
          }
          .m-right-p{
            margin-top: 12px;
          }
          .m-ai-box{
            width: 100px;
            height: 130px;
            margin-top: 8px;
            background: #f1f3f7;
            text-align: center;
            >span{
              font-size: 12px;
              position: relative;
              top:60px;
            }
            img{
              width: 100px;
              height: 130px;
            }
          }
          .m-ai{
            margin-top: 12px;
            font-size: 12px;
          }
        }
      }
    }
    .des-bg{
      color: #666666;
      font-size: 14px;
      line-height: 18px;
      /*padding: 12px 5px 20px 5px;*/
    }
  }
  .m-html{
    padding: 10px;
    /deep/b{
      font-weight: 600;
    }
    /deep/img{
      max-width: 100%;
      object-fit: contain;
    }
  }
</style>

